import { Theme } from '@mui/material/styles'

export const styles = {
  button: {
    marginBottom: (theme: Theme) => theme.spacing(1),
    marginLeft: (theme: Theme) => theme.spacing(1),
  },
}
